module.exports = __webpack_public_path__ + "img/4-3.7120597.png";